
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"64","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M63.062 61.19h-1.066V27.785l.596.343a.94.94 0 001.281-.337.926.926 0 00-.34-1.272L32.471 8.622a.944.944 0 00-.942 0L.467 26.518a.926.926 0 00-.34 1.272.941.941 0 001.281.337l.596-.343V61.19H.938a.934.934 0 00-.938.93c0 .514.42.93.938.93h62.124a.934.934 0 00.938-.93c0-.514-.42-.93-.938-.93zm-13.963 0H14.9v-3.11H49.1v3.11zm0-9.941H20.978a.934.934 0 00-.938.93c0 .514.42.93.938.93h28.12v3.11H14.902v-3.11h2.069a.934.934 0 00.937-.93c0-.514-.42-.93-.937-.93H14.9v-3.111H49.1v3.11zm0-9.943H47.03a.934.934 0 00-.937.93c0 .514.42.93.937.93H49.1v3.111H14.9v-3.11h28.121a.934.934 0 00.938-.93c0-.515-.42-.931-.938-.931h-28.12v-3.11h34.197v3.11zM60.12 61.191h-9.147V37.265c0-.514-.42-.93-.938-.93H13.964a.934.934 0 00-.938.93v23.926H3.88V26.704L32 10.502l28.121 16.202V61.19z","fill":"#1BA7E1"}})])
          )
        }
      }
    